import { normalize } from 'normalizr';
import { query } from '@/dex-shared/helpers/graphql';
import { question, board } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_HIGHLIGHTED_SUBJECTS(
    { commit }: any,
    { page, items }: { page: number; items: number },
  ) {
    const response = await query(
      `query ($items: Int!, $offset: Int) {
        boardBySlug(slug: "redacao") {
          id
          title
          materialsByBoardId (
            first: $items
            offset: $offset
            condition: {
              highlighted: true
            }
          ) {
            nodes {
              id
              highlighted
              questionByQuestionId {
                id
                title
                slug
                createdAt
                examModeId
              }
            }
          }
        }
      }`,
      {
        offset: (page - 1) * items,
        items,
      },
    );
    const normalizedBoard = normalize(response.data.boardBySlug, board);
    commit('SET_NORMALIZED_DATA', normalizedBoard.entities);
  },
  async PULL_SUBJECTS(
    { commit }: any,
    { page, items }: { page: number; items: number },
  ) {
    const response = await query(
      `query ($items: Int!, $offset: Int) {
        allEssaySubjects(
          first: $items
          offset: $offset
        ) {
          nodes {
            id
            title
            slug
            examModeByExamModeId {
              id
              name
            }
          }
        }
        boardBySlug(slug: "redacao") {
          id
          title
          materialsByBoardId(
            first: $items
            offset: $offset
            condition: {
              highlighted: true
            }
          ) {
            nodes {
              id
              highlighted
              questionByQuestionId {
                id
                title
                slug
                examModeByExamModeId {
                  id
                  name
                }
              }
            }
          }
        }
      }`,
      {
        offset: (page - 1) * items,
        items,
      },
    );
    const normalizedExamModes = normalize(
      response.data.allEssaySubjects.nodes,
      [question],
    );
    commit('SET_NORMALIZED_DATA', normalizedExamModes.entities);
    const normalizedBoard = normalize(response.data.boardBySlug, board);
    commit('SET_NORMALIZED_DATA', normalizedBoard.entities);
  },
  async PULL_SUBJECTS_BY_MODE(
    { commit }: any,
    {
      page,
      items,
      examModeId,
    }: { page: number; items: number; examModeId: number },
  ) {
    const response = await query(
      `query ($examModeId: Int!, $items: Int!, $offset: Int) {
        allEssaySubjects(
          filter: {
            examModeId: {
              equalTo: $examModeId
            }
          }
          first: $items
          offset: $offset
        ) {
          nodes {
            id
            title
            slug
            createdAt
            examModeId
          }
        }
      }`,
      {
        examModeId,
        offset: (page - 1) * items,
        items,
      },
    );
    const normalizedResponse = normalize(response.data.allEssaySubjects.nodes, [
      question,
    ]);
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async PULL_SUBJECT({ commit }: any, slug: string) {
    const response = await query(
      `query GetSubject($slug: String!) {
      questionBySlug(slug: $slug) {
        id
        title
        slug
        createdAt
        examModeId
        contentsByQuestionId {
          nodes {
            id
            position
            questionId
            textByTextId {
              id
              source
              body
              alignment
            }
            imageByImageId {
              id
              url
              source
              resizeFactor
              description
              alt
            }
            videoByVideoId {
              id
              providerType
              providerId
              source
            }
          }
        }
      }
    }`,
      { slug },
    );
    const normalizedResponse = normalize(
      response.data.questionBySlug,
      question,
    );
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
};
